import { RootState } from 'store';
import Repository from './Repository';

const getLocalizedText = (key: string) => {
  if (!key) return '';

  const { localization } = Repository.get('store').getState() as RootState;
  const { interfaceLang, localeDictionaries } = localization;
  key = key.trim();

  try {
    if (localeDictionaries && interfaceLang) {
      return localeDictionaries[interfaceLang][key] || key;
    }
  } catch (e) {
    return key;
  }
};

export default getLocalizedText;
